export default __webpack_public_path__ + "static/media/TheWorldMexico_05.1a623cbe.png";